import { AxiosInstance, CancelToken } from 'axios';
import axios from 'axios';
import { get } from 'lodash';
import config from 'config/Config';
import { initAxios } from 'utils/axios';

interface CapacityPerWeekEntry {
  startDate: string; // Date in str form
  endDate: string; // Date in str form
  assigned: string;
  timeOff: string;
  capacity: string;
}

interface CapacityPerWeek {
  [week: string]: CapacityPerWeekEntry | undefined;
}

export interface WeeklyTeamCapacityApiResponse {
  id: string;
  weeklyCapacities: CapacityPerWeek;
  links: {
    next: string;
    prev: string;
  };
}

export interface FetchWeeklyTeamParams {
  url: string;
  cancelToken?: CancelToken;
}

export interface FetchWeeklyTeamMemberParams {
  teamId: string;
  teamMemberId: string;
  startDate: string;
  endDate?: string;
  url?: string;
  cancelToken?: CancelToken;
}

class WeeklyTeamCapacityAPI {
  instance: AxiosInstance;

  constructor() {
    this.instance = initAxios(config.get('backendURL'), 'resourcing');
  }

  fetchWeeklyCapacityForTeam = async ({
    url,
    cancelToken,
  }: FetchWeeklyTeamParams): Promise<WeeklyTeamCapacityApiResponse> => {
    const response = await this.instance.get<WeeklyTeamCapacityApiResponse>(
      url,
      { cancelToken }
    );
    if (axios.isAxiosError(response)) {
      const errorMessage = get(response, 'response.data.message', '');
      throw errorMessage;
    }
    return response.data;
  };

  fetchWeeklyCapacityForTeamMember = async ({
    teamId,
    teamMemberId,
    startDate,
    endDate,
    url: providedUrl,
    cancelToken,
  }: FetchWeeklyTeamMemberParams): Promise<WeeklyTeamCapacityApiResponse> => {
    const url =
      providedUrl ||
      `/v2/teams/${teamId}/members/${teamMemberId}/capacities/weekly`;

    const response = await this.instance.get<WeeklyTeamCapacityApiResponse>(
      url,
      providedUrl
        ? { cancelToken }
        : {
            params: {
              startDate,
              endDate,
            },
            cancelToken,
          }
    );
    if (axios.isAxiosError(response)) {
      const errorMessage = get(response, 'response.data.message', '');
      throw errorMessage;
    }
    return response.data;
  };
}

const weeklyTeamCapacityAPI = new WeeklyTeamCapacityAPI();

export default weeklyTeamCapacityAPI;

export { WeeklyTeamCapacityAPI };

export const fetchWeeklyCapacityForTeam = async (
  params: FetchWeeklyTeamParams
): Promise<WeeklyTeamCapacityApiResponse> => {
  return weeklyTeamCapacityAPI.fetchWeeklyCapacityForTeam(params);
};

export const fetchWeeklyCapacityForTeamMember = async (
  params: FetchWeeklyTeamMemberParams
): Promise<WeeklyTeamCapacityApiResponse> => {
  return weeklyTeamCapacityAPI.fetchWeeklyCapacityForTeamMember(params);
};
